import type { AppRedirect } from '#src/shared/routes';

export const REDIRECTS: readonly AppRedirect[] = [
	{
		path: '/admin/decision-makers/consolidate',
		buildUrl: () => '/admin/decision-makers',
		reason: 'deprecated-page',
		permanent: true,
	},
];
